
import styled from 'styled-components';
import { Button as ButtonMui, Popper as PopperMui } from '@mui/material';

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: calc(100% - 67px);
  overflow-y: auto;
  overflow: -moz-scrollbars-none;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar { 
    display: none; 
  }
  .textarea {
    height: 90px;
    .MuiInputBase-root {
      padding-top: 10px !important;
      padding-bottom: 0px !important;
      height: 90px !important;
      align-items: flex-start !important;
    }
  }
  span.r-title {
    color: #595959;
    font-size: 16px;
    font-weight: 700;
  }
  span.r-sub {
    color: #99ACC2;
    font-size: 16px;
    font-weight: 700;
  }
  .mb15 {
    margin-bottom: 15px;
  }
  .mt15 {
    margin-top: 15px;
  }
  .MuiInputBase-root {
    height: 48px;
    &.MuiInputBase-multiline {
      height: 90px
    }
    textarea {
      padding-top: 0px;
    }
  }
  .h-price {
    color: #99ACC2;
    font-size: 20px;
    font-weight: 700; 
  }
  .h-title {
    color: #595959;
    font-size: 24px;
    font-weight: 700; 
  }
  .h-sub {
    color: #595959;
    font-size: 18px;
  }
  .MuiChip-root {
    background-color: #595959;
    border: none;
    color: #ffffff;
    svg {
      color: #ffffff;
    }
  }
  .tooltip {
    width: 30px;
    height: 30px;
    background-color: #ebf0f6;
    border-radius: 15px;
    text-align: center;
    box-sizing: border-box;
    padding-top: 3px;
    cursor: pointer;
    position: absolute;
    top: 0px;
    right: 0px;
    color: #0073a3;
    font-weight: bold;
  }
  .MuiAccordion-root {
    border: none !important;
    position: inherit !important;
    .MuiAccordionSummary-root {
      padding: 0px 5px;
      margin-bottom: 10px;
    }
    .MuiButtonBase-root {
      background-color: #ebf0f6 !important;
      border-radius: 0px;
      position: relative;
      height: 50px;
      &:before {
        position: absolute;
        background-color: #ebf0f6 !important;
        content: '';
        width: 25px;
        height: 50px;
        left: -25px;
      }
      &:after {
        position: absolute;
        background-color: #ebf0f6 !important;
        content: '';
        width: 25px;
        height: 50px;
        right: -25px;
      }
    }
    .MuiInputBase-root {
      margin-top: 8px;
    }
  }
  .MuiAccordion-root .MuiButtonBase-root.delete-button {
    background-color: #800000 !important;
    &:after, &:before {
      display: none;
    }
  }
  .autocomplete {
    .MuiInputBase-root {
      height: auto;
      min-height: 48px;
    }
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #ebf0f6;
  padding: 24px;
  padding-top: 0px;
  padding-bottom: 24px;
  h2 {
    color: #595959;
    font-size: 32px;
    margin-top: 0px;
    margin-bottom: 0px;
    font-weight: 400;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 24px;
  padding-bottom: 5px;
  &.buttons {
    padding-top: 0px;
  }
`;

export const Row = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const Col = styled.div`
  display: flex;
  position: relative;
  flex: 1;
  flex-direction: column;
  justify-content: ${({ flexEnd }) => flexEnd ? 'flex-end' : 'flex-start'};
  text-align: ${({ flexEnd }) => flexEnd ? 'right' : 'left'};
  padding-right: ${({ paddingRight }) => paddingRight ? '5px' : '0px'};
  padding-left: ${({ paddingLeft }) => paddingLeft ? '5px' : '0px'};
`;

export const ColButton = styled.div`
  display: flex;
  flex: 1;
  :first-of-type {
    padding-right: 10px;
  }
  :last-of-type {
    padding-left: 10px;
  }
`;

export const TableBig = styled.div`
  width: 100%;
  min-height: 20px;
  background-color: #ffffff;
  border: solid 1px #99ACC2;
  border-radius: 3px;
`;

export const TRow = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  :last-of-type {
    border-top: solid 1px #99ACC2;
  }
`;

export const TCol = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 10px;
  :last-of-type {
    border-left: solid 1px #99ACC2;
  }
`;

export const Tabs = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 20px;
`;

export const Tab = styled.div`
  width: auto;
  height: 100%;
  background-color: ${({ active }) => active ? 'white' : 'transparent'};
  display: flex;
  align-items: center;
  padding: 15px;
  border-top: ${({ active }) => active ? 'solid 2px #1080ad' : 'none'};
  box-sizing: border-box;
  cursor: pointer;
  span {
    color: ${({ active }) => active ? '#1080ad' : '#595959'};
    font-size: 16px;
    font-weight: 700;
  }
  label {
    margin-left: 5px;
    color: #595959;
    font-size: 1.1em;
}
`;

export const Button = styled(ButtonMui)`
  flex: 1;
  height: 48px;
  span {
    text-transform: none !important;
    font-size: 16px;
    font-weight: 700;
  }
`;

export const OptionText = styled.label`
  font-size: 0.9em !important;
`;

export const Box = styled.div`
  width: 100%;
  height: auto;
  margin-bottom: 10px;
`;

export const Br = styled.div`
  width: 100%;
  height: 10px;
`;

export const Popper = styled(PopperMui)`
  z-index: 1000;
  width: 310px;
  max-width: 310px;
  /*transform: none !important;*/
  /*left: inherit !important;*/
  /*bottom: 0px !important;*/
  /*right: 0 !important;*/
  border: solid 1px #CBD6E2;
  box-shadow: -5px 4px 13px -4px rgb(0 0 0 / 22%);
  .p-header {
    background-color: #ebf0f6;
    padding: 5px;
    padding-left: 10px;
    box-sizing: border-box;
  }
  .h-title {
    color: #595959;
    font-size: 14px;
    font-weight: bold; 
  }
  span.r-title {
    color: #595959;
    font-size: 14px;
    font-weight: 700;
  }
  .MuiSelect-root, input, p {
    font-size: 12px;
  }
  .MuiInputBase-root {
    max-width: 145px;
  }
`;

export const Icon = styled.div`
  display: block;
  float: right;
  cursor: pointer;
`;

export const SaveChip = styled.div`
  width: 100%;
  border: solid 1px #0073a3;
  height: 40px;
  border-radius: 4px;
  margin-bottom: 16px;
  padding-top: 5px;
  padding-left: 10px;
  padding-right: 10px;
  span {
    color: #0073a3;
    font-size: 16px;
    font-weight: 400;
  }
  svg {
    float: right;
    color: #0073a3;
  }
`;

export const ErrorChip = styled.div`
  width: 100%;
  border: solid 1px #f44336;
  height: 40px;
  border-radius: 4px;
  margin-bottom: 16px;
  padding-top: 6px;
  padding-left: 10px;
  padding-right: 10px;
  span {
    color: #f44336;
    font-size: 16px;
    font-weight: 400;
  }
  svg {
    float: right;
    color: #f44336;
  }
`;